import { render, staticRenderFns } from "./Malfunctions.vue?vue&type=template&id=daeb0e98&scoped=true"
import script from "./Malfunctions.vue?vue&type=script&lang=ts"
export * from "./Malfunctions.vue?vue&type=script&lang=ts"
import style0 from "./Malfunctions.vue?vue&type=style&index=0&id=daeb0e98&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "daeb0e98",
  null
  
)

export default component.exports